import { DateTime } from "luxon";
import { IAttachmentModel, AttachmentModel } from ".";


export interface IPetAttachmentModel extends IAttachmentModel {
    petAttachmentId: number;
    petId: number;
    notes: string | undefined;
    dateCreated: string;
    userCreated: string;
    hospitalName: string
}

export class PetAttachmentModel extends AttachmentModel implements Record<keyof IPetAttachmentModel, any> {
    petAttachmentId: number;
    petId: number;
    dateCreated: DateTime;
    userCreated: string;
    hospitalName: string

    constructor(params: IPetAttachmentModel) {
        super(params, params.petAttachmentId, "Pet", params.petId, params.notes);
        this.petAttachmentId = params.petAttachmentId;
        this.petId = params.petId;
        this.dateCreated = DateTime.fromISO(params.dateCreated);
        this.userCreated = params.userCreated;
        this.hospitalName = params.hospitalName;
    }

}
